import React, { useEffect, useState } from 'react';

import { Button, CardBody, CardFooter, Col, Form, Row } from 'reactstrap';
import Select from 'react-select';

import { CardListSimple } from '../../../../components/card_list_simple';
import { useDispatch, useSelector } from 'react-redux';
import { Offices } from '../../../../store/actions';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { APIClient } from '../../../../helpers/api_helper';

import { useLoading } from '../../../../hook/useLoading';

export const FormOfficeSelect = (props) => {
  const [parentSelect, setParentSelect] = useState({});

  const [listOffices, setListOffices] = useState([]);

  const dispatch = useDispatch();
  const api = new APIClient();
  const { loadingWithTime } = useLoading();

  const { offices } = useSelector((state) => ({
    offices: state.Offices.offices,
  }));

  const loadOptions = async () => {
    const response = await api.get(`/register/user-office`);
    const result = await response;

    const filterResult = result.filter((item) => item.user_id === props.userId);

    setListOffices(
      await filterResult.map((ofc) => ({
        officeId: ofc.office_id,
        officeInput: ofc.office_name,
        id: ofc.id,
      }))
    );
  };

  const sendOffices = async (id_office) => {
    await api.create(`/register/user-office`, {
      user_id: props.userId,
      office_id: id_office,
    });
  };

  /**
   * function to create custom data for select input
   * based on data passing as props
   */
  const createDataSelect = (data) => {
    return data.map((item) => {
      return {
        value: item.id,
        label: item.name,
      };
    });
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      officeInput: '',
    },
    validationSchema: Yup.object({
      officeInput: Yup.object().required('Selecione um escritório'),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        officeInput: parentSelect.label,
        officeId: parentSelect.value,
      };

      loadingWithTime(1000);
      sendOffices(parentSelect.value).then(() => {
        loadOptions();
      });
    },
  });

  const handleDeleteDependent = async (id) => {
    await api.delete(`/register/user-office/${id}`).then(() => {
      loadOptions();
    });
  };

  useEffect(() => {
    dispatch(Offices());
    loadOptions();
  }, [dispatch, props.userId]);

  return offices ? (
    <div>
      <Form
        id="form2"
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <CardBody>
          <div
            style={{
              marginBottom: '20px',
            }}
          >
            <h5>Escritórios</h5>
          </div>
          <div>
            <Row className="g-3">
              <Col sm={12} md={12} lg={12}>
                <Select
                  isClearable={true}
                  value={
                    parentSelect || {
                      value: 'null',
                      label: 'Selecione uma categoria',
                    }
                  }
                  onChange={(e) => {
                    const event = {
                      target: {
                        name: 'officeInput',
                        value: e,
                      },
                    };
                    validation.handleChange(event);
                    setParentSelect(e);
                  }}
                  onBlur={validation.handleBlur}
                  options={createDataSelect(offices) || []}
                  inputId="officeInput"
                />
                {validation.touched.officeInput &&
                validation.errors.officeInput ? (
                  <p className="labelErrorValidation">
                    {validation.errors.officeInput}
                  </p>
                ) : null}
              </Col>

              {listOffices.length > 0 && (
                <Col sm={12}>
                  <CardListSimple
                    data={listOffices || []}
                    handleDelete={(id) => handleDeleteDependent(id)}
                    accessorDelete="id"
                    columns={[
                      {
                        header: 'Escritório',
                        accessor: 'officeInput',
                      },
                    ]}
                  />
                </Col>
              )}
            </Row>
          </div>
        </CardBody>
        <CardFooter>
          <Col sm={12} className="d-flex justify-content-end">
            <Button type="submit">
              Adicionar
              <i className="fa fa-plus"></i>
            </Button>
          </Col>
        </CardFooter>
      </Form>
    </div>
  ) : null;
};
